namespace RioERP.Web.Enums {
    export enum UserRole {
        Manager = 1,
        SalesExecutive = 2,
        TechSupport = 3
    }
    Serenity.Decorators.registerEnumType(UserRole, 'RioERP.Web.Enums.UserRole');
}
